export function mainSlider() {
    const mainSlider = $(".main-slider");
    const sliderPlayBtn = $(".main-slider-holder .slider-play");
    const sliderDots = $(".slider-control .slick-dots");
    mainSlider.slick({
        arrows: false,
        dots: true,
        appendDots: ".main-slider-holder .slider-control",
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplaySpeed: 5000,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: true,
        fade: true
    }).on("afterChange", function () {
        setTimeout(() => {
            mainSlider.find(".slick-current").attr("tabindex", "0");
        }, 100);
        mainSlider.find(".slick-dots .slick-active").find("button").focus();
    });


    sliderPlayBtn.on("click", function () {
        let $this = $(this);
        if ($this.hasClass("pause")) {
            $this.removeClass("pause");
            mainSlider.slick("slickPause");
            sliderPlayBtn.find("span").text("Slider play");
        } else {
            $this.addClass("pause");
            mainSlider.slick("slickPlay");
            sliderPlayBtn.find("span").text("Slider pause");
        }
    });
    $(".main-slider-holder").find(".slider-play, .slick-dots").focusin(function () {
        if (sliderPlayBtn.hasClass("pause")) {
            mainSlider.slick("slickPause");
        }

    });
    $(".main-slider-holder").find(".slider-play, .slick-dots").focusout(function () {
        if (sliderPlayBtn.hasClass("pause")) {
            mainSlider.slick("slickPlay");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/main-slider.js